import ComparisonChip from "../UI/chips/ComparisonChip";

const KpiComparisonDistance = ({
  value,
  compareValue,
  variant,
}: {
  value: number;
  compareValue: number;
  variant?: "chip" | "icon";
}) => (
  <ComparisonChip
    positiveIndicator="NEGATIVE"
    value={Math.round(value - compareValue)}
    id={compareValue}
    unit="km"
    variant={variant}
  />
);

export default KpiComparisonDistance;
